import React, { useEffect, useState } from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';
import { ActionButton } from '../action-button/action-button';
import { ActionButtonLabel } from '../action-button-label/action-button-label';
import { ActionButtonIcon } from '../action-button-icon/action-button-icon';
import { Animate } from '../../../animate/animate';
import { OWNERSHIP_STATUSES } from '../../../../widget';
import styles from './actions-panel.scss';
const defaultProps = {
  onAllCardsButtonClick: noop,
  onBuyRentButtonClick: noop,
  onVideoInfoShow: noop,
  onShareVideoShow: noop,
  pauseVideo: noop,
  exitFullScreen: noop,
  isControlsShown: true
};
export const ActionsPanel = props => {
  const {
    pauseVideo,
    onAllCardsButtonClick,
    onCommentsButtonClick,
    onVideoInfoShow,
    onShareVideoShow,
    exitFullScreen,
    areElementsRounded,
    canShowBuyRentButton,
    canShareVideo,
    canShowFullInfo,
    canShowAllCardsButton,
    canShowCommentsButton,
    buyRentButtonText,
    videoInfoFullText,
    videoInfoShortText,
    shareVideoFullText,
    shareVideoShortText,
    showAllCardsFullText,
    commentsFullText,
    commentsShortText,
    showAllCardsShortText,
    infoButtonAriaLabel,
    shareButtonAriaLabel,
    allCardsButtonAriaLabel,
    commentsButtonAriaLabel,
    shouldShowCommentsPimple,
    videoOwnershipStatus,
    isRTL,
    isFocusable,
    isControlsShown
  } = {
    ...defaultProps,
    ...props
  };
  const [isMainContentHidden, setIsMainContentHidden] = useState(!isControlsShown);
  const show = () => {
    setIsMainContentHidden(false);
  };
  const hide = () => {
    setIsMainContentHidden(true);
  };
  const handleAllCardsButtonClick = event => {
    pauseVideo();
    onAllCardsButtonClick(event);
  };
  const handleCommentsButtonClick = () => {
    onCommentsButtonClick();
  };
  const onBuyRentButtonClick = event => {
    if (onBuyRentButtonClick) {
      pauseVideo();
      exitFullScreen();
      onBuyRentButtonClick(event);
    }
  };
  const getBuyRentIconName = () => {
    switch (videoOwnershipStatus) {
      case OWNERSHIP_STATUSES.YOU_BOUGHT_THIS:
        return 'film';
      case OWNERSHIP_STATUSES.YOU_RENTED_THIS:
        return 'timer';
      default:
        return 'dollar';
    }
  };
  useEffect(() => {
    if (isControlsShown) {
      if (isMainContentHidden) {
        show();
      }
    } else {
      hide();
    }
  }, [isControlsShown, isMainContentHidden]);
  const rtlClassConfig = {
    [styles.rtl]: isRTL,
    [styles.ltr]: !isRTL
  };
  const actionButtonClasses = classnames(styles.actionButton, rtlClassConfig);
  return /*#__PURE__*/React.createElement("section", {
    className: styles['main-content-wrapper'],
    "data-hook": "player-overlay-actions"
  }, /*#__PURE__*/React.createElement(Animate, {
    type: "fade-in-out",
    className: styles['main-content'],
    when: !isMainContentHidden
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-content-inner']
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.actions, rtlClassConfig)
  }, canShowBuyRentButton && /*#__PURE__*/React.createElement(ActionButton, {
    className: classnames(actionButtonClasses, styles['buy-rent-button'], {
      [styles['with-label']]: buyRentButtonText
    }),
    dataHook: "paid-access-button",
    isFocusable: isFocusable,
    onClick: onBuyRentButtonClick,
    rounded: areElementsRounded
  }, buyRentButtonText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
    className: styles['button-label'],
    label: buyRentButtonText
  }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
    icon: getBuyRentIconName()
  })), canShowFullInfo && /*#__PURE__*/React.createElement(ActionButton, {
    className: classnames(actionButtonClasses, styles.animatedButton, styles['video-info-button']),
    dataHook: "video-info-button",
    isFocusable: isFocusable,
    onClick: onVideoInfoShow,
    ariaLabel: infoButtonAriaLabel,
    rounded: areElementsRounded
  }, videoInfoFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
    className: styles['button-label'],
    label: videoInfoFullText,
    shortLabel: videoInfoShortText
  }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
    icon: "info"
  })), canShareVideo && /*#__PURE__*/React.createElement(ActionButton, {
    className: classnames(actionButtonClasses, styles.animatedButton, styles['share-button']),
    dataHook: "share-button",
    isFocusable: isFocusable,
    onClick: onShareVideoShow,
    ariaLabel: shareButtonAriaLabel,
    rounded: areElementsRounded
  }, shareVideoFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
    className: styles['button-label'],
    label: shareVideoFullText,
    shortLabel: shareVideoShortText
  }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
    icon: "share"
  })), canShowAllCardsButton && /*#__PURE__*/React.createElement(ActionButton, {
    className: classnames(actionButtonClasses, styles.animatedButton, styles['all-cards-button']),
    dataHook: "all-cards-button",
    isFocusable: isFocusable,
    onClick: handleAllCardsButtonClick,
    ariaLabel: allCardsButtonAriaLabel,
    rounded: areElementsRounded
  }, showAllCardsFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
    className: styles['button-label'],
    label: showAllCardsFullText,
    shortLabel: showAllCardsShortText
  }), /*#__PURE__*/React.createElement(ActionButtonIcon, {
    icon: "spark"
  })), canShowCommentsButton && /*#__PURE__*/React.createElement(ActionButton, {
    className: classnames(actionButtonClasses, styles.animatedButton, styles['chat-button']),
    dataHook: "chat-button",
    isFocusable: isFocusable,
    onClick: handleCommentsButtonClick,
    ariaLabel: commentsButtonAriaLabel,
    rounded: areElementsRounded
  }, commentsFullText && /*#__PURE__*/React.createElement(ActionButtonLabel, {
    className: styles['button-label'],
    label: commentsFullText,
    shortLabel: commentsShortText
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['chat-big']
  }, /*#__PURE__*/React.createElement(ActionButtonIcon, {
    icon: "chatBig"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['chat-small']
  }, /*#__PURE__*/React.createElement(ActionButtonIcon, {
    icon: "chatSmall"
  })), shouldShowCommentsPimple && /*#__PURE__*/React.createElement("div", {
    className: styles['chat-pimple']
  }))))));
};
//# sourceMappingURL=actions-panel.js.map